module.exports = __webpack_public_path__ + "img/face28.3f6a7e69.gif";